import { render, staticRenderFns } from "./entry-date-range-fields.vue?vue&type=template&id=35c378cd&scoped=true"
import script from "./entry-date-range-fields.vue?vue&type=script&lang=js"
export * from "./entry-date-range-fields.vue?vue&type=script&lang=js"
import style0 from "./entry-date-range-fields.vue?vue&type=style&index=0&id=35c378cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c378cd",
  null
  
)

export default component.exports